import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Matar extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  getWorkOrder(payload) {
    const url = this._getFullURL("/matar/get-asset-work-order");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  customMatar(payload) {
    const url = this._getFullURL("/matar/custom-matar");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  calculateMatar(payload) {
    const url = this._getFullURL("/matar/new-calculation");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  saveSimulation(payload) {
    const url = this._getFullURL("/matar/save-simulation");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  updateBulkSimulation(payload) {
    const url = this._getFullURL("/matar/update-bulk-simulation");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  saveBulkSimulation(payload) {
    const url = this._getFullURL("/matar/save-bulk-simulation");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  markDefault(payload) {
    const url = this._getFullURL("/matar/mark-default");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  getStrategy(payload) {
    const url = this._getFullURL("/matar/get-strategy");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  getOneStrategy(payload) {
    const url = this._getFullURL("/matar/get-one-strategy");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  getOneGroup(payload) {
    const url = this._getFullURL("/matar/get-one-group");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  getOverview(payload) {
    const url = this._getFullURL("/matar/overview");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  createGroup(payload) {
    const url = this._getFullURL("/matar/create-group");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  updateGroup(payload) {
    const url = this._getFullURL("/matar/update-group");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  getGroupMatar(payload) {
    const url = this._getFullURL("/matar/get-group-asset");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  deleteGroup(payload) {
    const url = this._getFullURL("/matar/delete-group-asset");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  deleteStrategy(payload) {
    const url = this._getFullURL("/matar/delete-financial-strategy");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  updateSimulation(payload) {
    const url = this._getFullURL("/matar/update-simulation");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  initiateData(payload) {
    const url = this._getFullURL("/matar/fill-default");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  getGroupWorkOrder(payload) {
    const url = this._getFullURL("/matar/get-group-asset");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
}
